import axios from '../../../config/axiosInstance';

// ─── Types ────────────────────────────────────────────────────────────────────

export type RaceStatus = 'planned' | 'registered' | 'confirmed' | 'completed' | 'cancelled';

export interface Race {
    id: string;
    raceType: string;
    date: string;
    location: string;
    notes: string | null;
    status: RaceStatus;
    finishTime: string | null;
    position: string | null;
    achievement: string | null;
    createdAt: string;
    updatedAt: string;
}

export interface CreateRaceInput {
    raceType: string;
    date: string;
    location: string;
    notes?: string;
    status?: RaceStatus;
    finishTime?: string;
    position?: string;
    achievement?: string;
}

export type UpdateRaceInput = Partial<CreateRaceInput>;

// ─── API calls ───────────────────────────────────────────────────────────────

export const getMyRaces = (): Promise<Race[]> =>
    axios.get('/races/me').then((r) => r.data);

export const createRace = (input: CreateRaceInput): Promise<Race> =>
    axios.post('/races/me', input).then((r) => r.data);

export const updateRace = (id: string, input: UpdateRaceInput): Promise<Race> =>
    axios.patch(`/races/me/${id}`, input).then((r) => r.data);

export const deleteRace = (id: string): Promise<void> =>
    axios.delete(`/races/me/${id}`).then(() => undefined);
